<template>
  <b-card  no-body class="p-2">
    <!-- Media -->
    <b-row>
      <b-col class="col-12 col-md-2 avatar-col">
        <b-avatar
          :src="avatarImage"
          variant="light-primary"
          size="100px"
          rounded
        />
        
      </b-col>
      
      <b-col class="col-12 mb-2 d-md-none">
          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-show="status == 'active'"
              class="mt-1"
              v-b-modal.grant-balance 
            >
              Grant Balance
          </b-button>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-show="status == 'pending'"
              class="mt-1"
              v-b-modal.activate-client-account
            >
              Approve Account
          </b-button>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-show="status == 'suspended'"
              class="mt-1"
              v-b-modal.activate-client-account
            >
              Re-Activate Account
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger"
            v-show="status == 'pending'"
            v-b-modal.reject-client-account
          >
            Reject Account
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger"
            v-show="status == 'active'"
            class="mt-1"
          v-b-modal.suspend-client-account
          >
            Suspend Account
        </b-button>
          </div>
          
      </b-col>

      <b-col class="col-12 col-md-10">
          <table class="table table-borderless">
            <tbody class="table-lg">
              <tr>
                <td>Name:</td>
                <th>{{firstName}} {{lastName}}</th>
                <td>Email:</td>
                <th>{{email}}</th>
                <td>Website:</td>
                <th>{{website}}</th>
                <td>User Type:</td>
                <th>
                  <span v-if="isCompany">Organization</span>
                  <span>Individual</span>
                </th>
                
              </tr>
              <tr>
                <td>Status:</td>
                <th class="text-capitalize">{{status}}</th>
                <td>Phone:</td>
                <th>{{phone}}</th>
                <td>Balance:</td>
                <th>BWP {{balance}}</th>
                <td>Registered At:</td>
                <th>
                  {{format_created_at}}
                </th>
              </tr>
            </tbody>
            <tbody class="table-md d-md-none">
              <tr>
                <td>Name:</td>
                <th>{{firstName}} {{lastName}}</th>
                <td>Email:</td>
                <th>{{email}}</th>
              </tr>
              <tr>
                <td>Status:</td>
                <th class="text-capitalize">{{status}}</th>
                <td>Phone:</td>
                <th>{{phone}}</th>
              </tr>

              <tr>
                <td>Website:</td>
                <th>{{website}}</th>
                <td>User Type:</td>
                <th>
                  <span v-if="isCompany">Organization</span>
                  <span>Individual</span>
                </th>
              </tr>
              <tr>
                <td>Balance:</td>
                <th>BWP {{balance}}</th>
                <td>Registered At:</td>
                <th>
                  {{format_created_at}}
                </th>
              </tr>
            </tbody>
            <tbody class="d-sm-none">
              <tr>
                <td>Name:</td>
                <th>{{firstName}} {{lastName}}</th>
              </tr>
              <tr>
                <td>Email:</td>
                <th>{{email}}</th>
              </tr>
              <tr>
                <td>Status:</td>
                <th class="text-capitalize">{{status}}</th>
              </tr>
              <tr>
                <td>Phone:</td>
                <th>{{phone}}</th>
              </tr>
              <tr>
                <td>Website:</td>
                <th>{{website}}</th>
              </tr>
              <tr>
                <td>User Type:</td>
                <th>
                  <span v-if="isCompany">Organization</span>
                  <span>Individual</span>
                </th>
              </tr>
              <tr>
                <td>Balance:</td>
                <th>BWP {{balance}}</th>
              </tr>
              <tr>
                <td>Registered At:</td>
                <th>
                  {{format_created_at}}
                </th>
              </tr>
            </tbody>
          </table>
        
      </b-col>

      <b-col class="col-12 mt-2 d-none d-md-flex">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="mr-2"
            v-show="status == 'active'"
            v-b-modal.grant-balance
          >
            Grant Balance
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="mr-2"
            v-show="status == 'pending'"
            v-b-modal.activate-client-account
          >
            Approve Account
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="mr-2"
            v-show="status == 'suspended'"
            v-b-modal.activate-client-account
          >
            Re-Activate Account
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-danger"
          v-show="status == 'pending'"
          v-b-modal.reject-client-account
        >
          Reject Account
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-danger"
          v-show="status == 'active'"
          v-b-modal.suspend-client-account
        >
          Suspend Account
        </b-button>
      </b-col>
    </b-row>

    <b-tabs pills class="mt-3">
      <hr />

      <b-tab
        lazy
        active
      >
        <template #title>
          Sender ID &nbsp;<b-badge variant="primary" pill>{{senderIdCounts}}</b-badge>
        </template>
        <sender-id :clientId="clientId"/>
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          SMS History &nbsp;<b-badge variant="primary" pill>{{outboxCounts}}</b-badge>
        </template>
        <outbox :clientId="clientId"/>
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          Scheduled SMS &nbsp;<b-badge variant="primary" pill>{{scheduledCounts}}</b-badge>
        </template>
        <scheduled-messages :clientId="clientId" @refresh-tabs-count="tabsCounts"/>
      </b-tab>

      <!-- <b-tab
        lazy
      >
        <template #title>
          Voice History &nbsp;<b-badge variant="primary" pill>{{outboxVoicesCounts}}</b-badge>
        </template>
        <outbox-voices :clientId="clientId"/>
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          Scheduled Voices &nbsp;<b-badge variant="primary" pill>{{scheduledVoicesCounts}}</b-badge>
        </template>
        <scheduled-voices :clientId="clientId" @refresh-tabs-count="tabsCounts"/>
      </b-tab> -->

      <b-tab
        lazy
      >
        <template #title>
          Transaction History &nbsp;<b-badge variant="primary" pill>{{transactionCount}}</b-badge>
        </template>
        <transaction-history :clientId="clientId"/>
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          Contacts &nbsp;<b-badge variant="primary" pill>{{contactsCounts}}</b-badge>
        </template>
        <contacts :clientId="clientId" @refresh-tabs-count="tabsCounts"/>
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          Invalid Contacts &nbsp;<b-badge variant="primary" pill>{{invalidContactsCounts}}</b-badge>
        </template>
        <invalid-contacts :clientId="clientId" @refresh-tabs-count="tabsCounts"/>
      </b-tab>
    </b-tabs>

    <grant-balance :id="clientId" @grant-balance-submited="refreshClientGrantBalance"/>
    <suspend-account :id="clientId" @suspend-account-submited="refreshClient"/>
    <reject-account :id="clientId" @reject-account-submited="refreshClient"/>
    <activate-account :id="clientId" @activate-account-submited="refreshClient"/>
  </b-card>
</template>

<script>
import {
  BButton,
  BSpinner,
  BAvatar,
  BCard,
  BTab,
  BTabs,
  BBadge,
  BCol,
  BRow,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
// import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";
import GrantBalance from "./components/GrantBalance.vue";
import SuspendAccount from "./components/SuspendAccount.vue";
import RejectAccount from "./components/RejectAccount.vue";
import ActivateAccount from "./components/ActivateAccount.vue";
import SenderId from "./tabs/SenderId.vue";
import Outbox from "./tabs/Outbox.vue";
import ScheduledMessages from "./tabs/ScheduledMessages.vue";
// import OutboxVoices from "./tabs/OutboxVoices.vue";
// import ScheduledVoices from "./tabs/ScheduledVoices.vue";
import TransactionHistory from "./tabs/TransactionHistory.vue";
import Contacts from "./tabs/Contacts.vue";
import InvalidContacts from "./tabs/InvalidContacts.vue";

export default {
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  components: {
    BCard,
    BButton,
    BSpinner,
    BAvatar,
    BTab,
    BTabs,
    BBadge,
    BCol,
    BRow,
    GrantBalance,
    SuspendAccount,
    RejectAccount,
    ActivateAccount,
    SenderId,
    Outbox,
    ScheduledMessages,
    // OutboxVoices,
    // ScheduledVoices,
    TransactionHistory,
    Contacts,
    InvalidContacts,
  },
  props:["clientId"],
  computed:{
    avatarImage() {
      if (this.image) {
        return this.appClientUrl + "/uploads/profile-pictures/" + this.reqImage;
      }
      return require("@/assets/images/avatars/default-profile.png");
    },
  },
  data() {
    const { appClientUrl } = $themeConfig.app;
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      image: null,
      website: null,
      isCompany: null,
      status: null,
      balance: null,
      format_created_at: null,
      contactsCounts:null,
      invalidContactsCounts:null,
      outboxCounts:null,
      scheduledCounts:null,
      // outboxVoicesCounts: null,
      // scheduledVoicesCounts: null,
      transactionCount:null,
      senderIdCounts:null,
      isBusy: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      appClientUrl: appClientUrl,
    };
  },
  methods:{
    refreshClient(){
      this.$http
      .get("/clients/refresh-client/" + this.clientId)
      .then((response) => {
        const client = response.data.data;
          this.status = client.status;
          this.balance = client.balance;
      })
    },
    refreshClientGrantBalance(){
      this.$http
        .get("/clients/refresh-client/" + this.clientId)
        .then((response) => {
          const client = response.data.data;
            this.status = client.status;
            this.balance = client.balance;

          this.$http
            .get("/credits/transaction-history/count?clientid=" + this.clientId)
            .then((response) => {
              this.transactionCount = response.data.data;
            })
        })
    },
    tabsCounts(){
      this.$http
        .get("/contacts/count?clientid=" + this.clientId)
        .then((response) => {
          this.contactsCounts = response.data.data;
        })

      this.$http
        .get("/contacts/count?invalid=true&clientid=" + this.clientId)
        .then((response) => {
          this.invalidContactsCounts = response.data.data;
        })

      this.$http
        .get("/scheduled-messages/count?clientid=" + this.clientId)
        .then((response) => {
          this.scheduledCounts = response.data.data;
        })

      // this.$http
      //   .get("/voice/scheduled-messages/count?clientid=" + this.clientId)
      //   .then((response) => {
      //     this.scheduledVoicesCounts = response.data.data;
      //   })
    },
    tabsCountsOnce(){
      this.$http
        .get("/outbox/count?clientid=" + this.clientId)
        .then((response) => {
          this.outboxCounts = response.data.data;
        })
      
      // this.$http
      //   .get("/voice/outbox/count?clientid=" + this.clientId)
      //   .then((response) => {
      //     this.outboxVoicesCounts = response.data.data;
      //   })

      this.$http
        .get("/credits/transaction-history/count?clientid=" + this.clientId)
        .then((response) => {
          this.transactionCount = response.data.data;
        })

      this.$http
        .get("/sender-id/count?clientid=" + this.clientId)
        .then((response) => {
          this.senderIdCounts = response.data.data;
        }) 
    }
  },
  created(){
    this.$http
      .get("/clients/" + this.clientId)
      .then((response) => {
        const client = response.data.data;
          this.firstName = client.first_name;
          this.lastName = client.last_name;
          this.email = client.email;
          this.phone = client.code + client.phone;
          this.image = client.image;
          this.website = client.website;
          this.isCompany = client.is_company;
          this.status = client.status;
          this.balance = client.balance;
          this.format_created_at = client.format_created_at;
      })

    this.tabsCountsOnce();
    this.tabsCounts();
  }
};
</script>
<style scoped>
@media (max-width: 767px) {
  .table-lg{
    display: none;
  }
  .avatar-col{
    text-align: center;
    margin-bottom: 2.5rem;
  }
}
@media (max-width: 575px) {
  .table-md{
    display: none;
  }
}
</style>
